// Who gets a nav path to Ask + Marketing: fully verified agents, free-plan users (limited
// free quota) and entitled users (Member/Pro/Team, paid or staff-granted) even before they
// verify their phone. Phone verification is still enforced server-side on use.
export const useCanSeeFreeFeatures = () => {
  const accessLevel = useAccessLevel();
  const { isFreePlanUser } = useFreePlan();
  const { entitlements } = useEntitlements();

  const isVerified = computed(() => accessLevel.value === 'verified');
  const isEntitled = computed(() => entitlements.value.tier !== 'PREVIEW');
  const canSeeFreeFeatures = computed(() => isVerified.value || isFreePlanUser.value || isEntitled.value);

  return {
    isVerified,
    isEntitled,
    canSeeFreeFeatures,
  };
};
